(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ccardsReady) return;
    root.dataset.ccardsReady = '1';
    var rooms = root.querySelectorAll('[data-room]');
    var slides = root.querySelectorAll('[data-slide]');
    if (!rooms.length || !slides.length) return;
    function show(i) {
      rooms.forEach(function (r) { r.classList.toggle('is-active', r.dataset.room === i); });
      slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.dataset.slide === i); });
    }
    rooms.forEach(function (r) {
      r.addEventListener('mouseenter', function () { show(r.dataset.room); });
      r.addEventListener('focus', function () { show(r.dataset.room); });
    });
  }
  function all() { document.querySelectorAll('.custom-ccards--piece[data-custom-ccards]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
